import { Droppable, Draggable } from '@hello-pangea/dnd';
import MenuItem from '../molecules/MenuItem';
import { IconInbox } from '../atoms/Icon';

function MenuList({
  categoryId,
  categoryIcon,
  products,
  onEdit,
  onDelete,
  onToggleAvailability,
  onMove,
  emptyLabel = 'Nenhum produto nesta categoria.',
  dragDisabled = false,
}) {
  return (
    <Droppable droppableId={`products-${categoryId}`} type="product" isDropDisabled={dragDisabled}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={snapshot.isDraggingOver ? 'menu-droppable-over' : undefined}
        >
          {!products?.length ? (
            <div className="text-center py-4 text-muted">
              <IconInbox size={32} style={{ color: '#ccc' }} />
              <p className="mt-2 mb-0" style={{ fontSize: 13 }}>{emptyLabel}</p>
            </div>
          ) : (
            products.map((product, index) => (
              <Draggable
                key={product.id}
                draggableId={product.id}
                index={index}
                isDragDisabled={dragDisabled}
              >
                {(dragProvided, dragSnapshot) => (
                  <MenuItem
                    product={product}
                    categoryIcon={categoryIcon}
                    onEdit={() => onEdit(product)}
                    onDelete={() => onDelete(product)}
                    onToggleAvailability={() => onToggleAvailability(product)}
                    onMoveUp={!dragDisabled && index > 0 ? () => onMove(product, -1) : null}
                    onMoveDown={!dragDisabled && index < products.length - 1 ? () => onMove(product, 1) : null}
                    innerRef={dragProvided.innerRef}
                    draggableProps={dragProvided.draggableProps}
                    dragHandleProps={dragDisabled ? null : dragProvided.dragHandleProps}
                    isDragging={dragSnapshot.isDragging}
                  />
                )}
              </Draggable>
            ))
          )}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default MenuList;
